<template>
  <v-layout
    @click="$emit('click')"
    column
    fill-height
    :class="`card-dash-${color} card-data`"
  >
    <template v-if="metrics && metrics.length">
      <!-- Linha superior: até 2 métricas + ícone -->
      <v-layout row class="pt-3 px-3 pb-1" justify-space-between>
        <v-layout
          v-for="(metric, index) in topMetrics"
          :key="`top-${index}`"
          column
          fill-height
          :class="['text-xs-left', { 'pl-1': index > 0 }]"
          :style="index > 0 ? 'margin-top: -4px' : ''"
        >
          <p class="title font-weight-bold">{{ metric.value }}</p>
          <p v-html="metric.label"></p>
        </v-layout>
        <span>
          <v-icon small color="white">{{ icon }}</v-icon>
        </span>
      </v-layout>

      <!-- Linha inferior: até 2 métricas -->
      <v-layout
        v-if="bottomMetrics.length"
        row
        class="pa-3"
        style="margin-bottom: 0px"
      >
        <v-layout
          v-for="(metric, index) in bottomMetrics"
          :key="`bottom-${index}`"
          column
        >
          <p class="title font-weight-bold">{{ metric.value }}</p>
          <p v-html="metric.label"></p>
        </v-layout>
      </v-layout>
    </template>
    <template v-else>
      <v-layout column align-center justify-center fill-height class="pa-4">
        <v-icon color="white" class="mb-2" medium>
          mdi-alert-circle-outline
        </v-icon>
        <span class="subheading"> Sem dados disponíveis </span>
      </v-layout>
    </template>
  </v-layout>
</template>

<script>
export default {
  name: "dashboard-card",

  props: {
    /**
     * Cor do gradiente do card.
     * Valores possíveis aqui: https://v15.vuetifyjs.com/en/framework/colors/
     */
    color: {
      type: String,
      required: true,
    },

    /**
     * Nome do ícone Material Design exibido no canto superior direito.
     * Ex: 'mdi-email', 'mdi-phone'
     */
    icon: {
      type: String,
      required: true,
    },

    /**
     * Lista de métricas exibidas no card (máximo 4).
     * Cada métrica é um objeto com:
     *   - value (String): valor principal exibido em destaque (já formatado)
     *   - label (String): legenda descritiva abaixo do valor
     *
     * Distribuição no layout:
     *   - metrics[0] e metrics[1] → linha superior
     *   - metrics[2] e metrics[3] → linha inferior
     *
     * Exemplo:
     *   [
     *     { value: '1,2 mil', label: 'Notificações enviadas' },
     *     { value: '800',     label: '66% entregue' },
     *     { value: 'R$ 1.500,00', label: '150,00 CC' },
     *     { value: 'R$ 2.000,00', label: '200,00 CC' },
     *   ]
     */
    metrics: {
      type: Array,
      required: true,
    },
  },

  computed: {
    topMetrics() {
      return this.metrics.slice(0, 2);
    },
    bottomMetrics() {
      return this.metrics.slice(2, 4);
    },
  },
};
</script>

<style lang="scss" scoped>
.card-data {
  border: 1px solid darkgrey;
  cursor: pointer;
  border-radius: 3px;
}
.card-dash-indigo {
  background: linear-gradient(
    to bottom right,
    #002984 0%,
    #3f51b5 100%
  ) !important;
  color: #fff !important;
}
.card-dash-brown {
  background: linear-gradient(
    to bottom right,
    #4b2c20 0%,
    #795548 100%
  ) !important;
  color: #fff !important;
}
.card-dash-light-green {
  background: linear-gradient(
    to bottom right,
    #5a9216 0%,
    #8bc34a 100%
  ) !important;
  color: #fff !important;
}
.card-dash-teal {
  background: linear-gradient(
    to bottom right,
    #00675b 0%,
    #009688 100%
  ) !important;
  color: #fff !important;
}
.card-dash-purple {
  background: linear-gradient(
    to bottom right,
    #6a0080 0%,
    #9c27b0 100%
  ) !important;
  color: #fff !important;
}
.icon-card-dash {
  font-size: 36px;
  position: absolute;
  right: 6px;
  top: 6px;
  float: right;
  background: rgba(0, 0, 0, 0.15);
  padding: 8px;
  border-radius: 25px;
}
</style>
